import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetMainArticlesAppendSucceed, EGetMainArticlesActionType } from './types';
import { IMainArticles } from '../../../types/mainArticles';

export const getMainArticlesAppendSucceed: (data: IMainArticles) => TGetMainArticlesAppendSucceed = actionGenerator<
  EGetMainArticlesActionType.AppendSucceed,
  IMainArticles
>(EGetMainArticlesActionType.AppendSucceed);
